(function () {
  "use strict";

  homeSearchService.$inject = ['trackingService', 'searchHelper'];
  angular
    .module('trainerWebApp.services')
    .factory('homeSearchService', homeSearchService);

  function homeSearchService(trackingService, searchHelper) {
    var _items, originalItems;

    function setup(params) {

      // add in $seriesName and $courseName to search courses/series separately
      (function (newItems) {
        var items = [];
        _.each(newItems, function (item) {
          switch (item.type) {
            case "online" :
              item.$courseName = item.name;
              break;
            case "live":
              item.$liveCourseName = item.name;
              break;
            case "series" :
              item.$seriesName = item.name;
              break;
            case "catalog" :
              item.$catalogName = item.name;
              break;
          }
          items.push(item);
        });
        setItems(items);
        setOriginalItems(items.concat());
      })((params.items || []).concat());


      function getItems() {
        return _items;
      }

      function setItems(items) {
        _items = items;
      }

      function getOriginalItems() {
        return originalItems;
      }

      function setOriginalItems(items) {
        originalItems = items;
      }

      function filterStrict(field) {
        return function (txt) {
          if (txt && txt !== 'all')
            setItems(_.filter(getItems(), searchHelper.filterFieldStrictForUnderscore(field)(txt)));

          return publicMethods;
        }
      }

      var fieldTrackingMap = {
        course: trackingService.pages.trainerHome.actions.searchByCourse,
        series: trackingService.pages.trainerHome.actions.searchBySeries,
        catalog: trackingService.pages.trainerHome.actions.searchByCatalog,
        trainerName: trackingService.pages.trainerHome.actions.searchByTrainerName,
        trainerEmail: trackingService.pages.trainerHome.actions.searchByTrainerEmail
      };

      function fieldTracking(name) {
        return function () {
          if (fieldTrackingMap[name])
            trackingService.trackEvent(trackingService.pages.trainerHome.name, fieldTrackingMap[name]);
        }
      }

      function getSuggestions(field) {
        return function () {
          return _.chain(getItems()).pluck(field).filter(_.identity).map(function (fieldValue) {
            return {
              name: fieldValue,
              id: fieldValue
            };
          }).value();
        }
      }

      var publicMethods = {
        filterByType: filterStrict('type'),
        filterByStatus: filterStrict('status'),

        /* filter via a composite search filter function */
        filterBy: function (fn) {
          if (fn)
            setItems(_.filter(getItems(), fn));

          return publicMethods;
        },

        /* tests a composite search filter function */
        testFilter: function (fn) {
          var ret = _.find(_items, fn);
          setItems(getOriginalItems().concat());
          return ret;
        },

        result: function () {
          var ret = _items.concat();
          setItems(getOriginalItems().concat());
          return ret;
        },

        fields: [
          {
            name: 'courseName',
            label: 'Course',
            shortcut: "courseName",
            createFilterSync: searchHelper.createCompositeSearchFieldFilter2(
              searchHelper.filterFieldStrict('$courseName')
            ),
            track: fieldTracking('course'),
            groupLabel: "Courses:",
            groupName: "coursesGroup",
            getSuggestions: getSuggestions('$courseName')
          },
          {
            name: 'liveCourseName',
            label: 'Live Training',
            shortcut: "liveCourseName",
            createFilterSync: searchHelper.createCompositeSearchFieldFilter2(
              searchHelper.filterFieldStrict('$liveCourseName')
            ),
            track: fieldTracking('liveCourse'),
            groupLabel: "Live Courses:",
            groupName: "liveCoursesGroup",
            getSuggestions: getSuggestions('$liveCourseName')
          },
          {
            name: 'seriesName',
            label: 'Series',
            shortcut: "seriesName",
            createFilterSync: searchHelper.createCompositeSearchFieldFilter2(
              searchHelper.filterFieldIndexOf('$seriesName')
            ),
            track: fieldTracking('series'),
            groupLabel: "Series:",
            groupName: "seriesGroup",
            getSuggestions: getSuggestions('$seriesName')
          },
          {
            name: 'catalogName',
            label: 'Catalog',
            shortcut: "catalogName",
            createFilterSync: searchHelper.createCompositeSearchFieldFilter2(
              searchHelper.filterFieldIndexOf('$catalogName')
            ),
            track: fieldTracking('catalog'),
            groupLabel: "Catalogs:",
            groupName: "catalogGroup",
            getSuggestions: getSuggestions('$catalogName')
          },
          {
            name: 'trainerName',
            label: 'Trainer Name',
            shortcut: "trainerName",
            createFilterSync: searchHelper.createCompositeSearchFieldFilter2(
              searchHelper.filterFieldIndexOf('trainerName')
            ),
            track: fieldTracking('trainerName'),
            groupLabel: "Trainer Names:",
            groupName: "trainersGroup"
          },
          {
            name: 'trainerEmail',
            label: 'Trainer Email',
            shortcut: "trainerEmail",
            createFilterSync: searchHelper.createCompositeSearchFieldFilter2(
              searchHelper.filterFieldIndexOf('trainerEmail')
            ),
            track: fieldTracking('trainerEmail'),
            groupLabel: "Trainers' Emails:",
            groupName: "trainersEmail"
          }
        ]
      };
      return publicMethods;
    }

    return {
      setup: setup
    }
  }

})();
